import Task from "../task";
import StartEndDurationManager from "../../../gd/manager/start-end-duration/start-end-duration-manager";
import workSchedule_getEstimatedEndDate from "../../work-week-schedule/functions/get-estimated-end-date"

const debug = false


export function calculateDisplayStartDate(task:Task):Moment {

    debug && console.log("    _calculateDisplayStartDate")

    // try init by startDate
    if (task.startDate) return task.startDate

    // we have no start date -> if open
    if (task.isOpen) {

        // use schedule date I guess :)
        if (task.scheduleDate) return task.scheduleDate

        // absolutely no dates found ... use next Working Day
        return new StartEndDurationManager().getCurrentOrNextWorkDay(task.actionRequiredUserId)
    } else {
        return task.momentCreated? momentDate(task.momentCreated) : momentDate()
    }


}

export function calculateDisplayEndDate(task:Task):Moment {
    // // try init by value
    // if (obj.displayEndDate) obj.displayEndDate

    // try init by startDate
    if (task.endDate) return task.endDate

    // we have no start date -> if open
    if (task.isOpen) {

        // try calculate based on estimate
        if (task.estimate) {
            return workSchedule_getEstimatedEndDate(task.assignedToUserId, task.displayStartDate, task.estimate)
        }

        // make 1 day... po idee mozno eche konechno s estimate igrat'... tipo duration
        return task.displayStartDate
    } else {
        if (task.momentClosed) return momentDate(task.momentClosed)
        if (task.latestActivityMoment) return momentDate(task.latestActivityMoment)

        // impossible case ? :)
        return task.displayStartDate
    }



}

export function calculateDisplayDates(task:Task) {
    task._displayStartDate   = calculateDisplayStartDate(task)
    task._displayEndDate     = calculateDisplayEndDate(task)
}

// this is used when we need to calculate a lag ...
// the thing is we prefer real start/end dates and if they dont' exist - display dates
export function getDatesForDependency(task: Task) {
    if (task.startDate && task.endDate) {
        return {
            start   : task.startDate,
            end     : task.endDate
        }
    }

    return {
        start   : calculateDisplayStartDate(task),
        end     : calculateDisplayEndDate(task)
    }
}
